import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-669d78b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "participant-step2" }
const _hoisted_2 = { class: "container font-Pretendar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cola-color" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold text-14" }, " 수거를 원하시는 제로 웨이스트 박스 개수를 입력해 주세요. "),
  /*#__PURE__*/_createElementVNode("h5", { class: "text-11" }, " 박스 수량만큼 택배 송장이 필요하니 정확한 수량을 선택해주세요 ")
], -1))
const _hoisted_4 = { ref: "formRef" }
const _hoisted_5 = { class: "form-item mt-sm-5 pt-5" }
const _hoisted_6 = { class: "text-center d-flex justify-content-center mt-5 pt-5" }

import ParticipantNumberInput from '@/templates/campaign-cocacola-season-6/components/participant-number-input.vue';
import ColaButton from '@/templates/campaign-cocacola-season-6/components/cola-button.vue';
import { ref } from 'vue';

interface FormType {
  number_bottle?: number;
}


export default /*#__PURE__*/_defineComponent({
  emits: ['next'],
  setup(__props, { emit }) {


const form = ref<FormType>({
  number_bottle: 1
});

//define emit


const handleSubmit = () => {
  if (!form?.value?.number_bottle) {
    return;
  }
  // Emit the form data to the parent component
  emit('next', form?.value);

};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ParticipantNumberInput, {
              modelValue: form.value.number_bottle,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.number_bottle) = $event)),
              min: 1,
              max: 2,
              step: 1
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(ColaButton, {
              class: "border-cola",
              title: "참여 신청하기",
              border: true,
              responsive: true,
              onClick: handleSubmit
            })
          ])
        ], 512)
      ])
    ])
  ]))
}
}

})